var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleFilled = function SvgCheckCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0m0 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m5.653 5.39a1.12 1.12 0 0 0-.837-.39c-.313 0-.615.14-.836.39l-6.107 6.883-1.836-2.158a1.2 1.2 0 0 0-.379-.298 1.065 1.065 0 0 0-.905-.02 1.2 1.2 0 0 0-.39.281 1.4 1.4 0 0 0-.263.427c-.063.16-.097.333-.1.508a1.43 1.43 0 0 0 .33.95L8.241 16.2c.204.248.45.447.723.584.274.138.57.21.869.216h.04c.293.001.583-.064.854-.19.272-.127.518-.313.725-.547l6.201-6.989c.222-.25.347-.588.347-.941s-.125-.692-.347-.942"
  }))));
};
export default SvgCheckCircleFilled;